import { render, staticRenderFns } from "./GraphicQuestions.vue?vue&type=template&id=0ba8bc98&scoped=true"
import script from "./GraphicQuestions.vue?vue&type=script&lang=js"
export * from "./GraphicQuestions.vue?vue&type=script&lang=js"
import style0 from "./GraphicQuestions.vue?vue&type=style&index=0&id=0ba8bc98&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba8bc98",
  null
  
)

export default component.exports